import troubles from "./bs_en_troubles";
export default [
  [
    {
      q: "Perché il Bluetooth non trova il mio veicolo?",
      a:
        "1.Verificare che il veicolo sia avviato e che sia in modalità P.<br/>\
        2.Controllare se la funzione Bluetooth del telefono cellulare è attivata o provare a riavviare la funzione Bluetooth del telefono.<br/>\
        (A causa del bug di sistema di Android 10, gli utenti che possiedono telefoni Android 10 devono attivare la funzione di posizionamento).<br/>\
      3. Controllare se il veicolo si trova in uno stato di collegamento in sospeso.<br/>\
      Per garantire la sicurezza del veicolo, dopo che il veicolo è entrato nello stato di collegamento in sospeso, se non si effettua alcuna operazione di spinta o di guida entro 2 minuti, il veicolo uscirà automaticamente dallo stato di collegamento in sospeso, oppure il veicolo non potrà essere trovato dal ricevitore Bluetooth.  È possibile avviare nuovamente il veicolo e completare il processo di attivazione tramite la ricerca nell'app entro un determinato periodo di tempo."
    },
    {
      q:
        "Faccio clic per connettere il veicolo trovato, ma l'app dice che la connessione non è riuscita?",
      a:
        "1.Verificare se il veicolo è nello stato vincolante.<br/>\
        Al fine di garantire la sicurezza del tuo veicolo, dopo che il veicolo è entrato nello stato vincolante, se non viene eseguita alcuna operazione, spinta o guida entro 5 minuti, il veicolo uscirà automaticamente dallo stato vincolante, quindi il veicolo non sarà in grado di connettersi.<br/>\
        Puoi completare l'operazione di attivazione riavviando il veicolo ed effettuando una ricerca tramite APP entro un tempo specifico.<br/>\
        2.È possibile che il segnale Bluetooth del tuo telefono cellulare sia instabile, con conseguenti difficoltà di connessione. Puoi provare ad attivare e disattivare la funzione bluetooth del telefono cellulare e riprovare a connetterti al veicolo."
    },
    {
      q:
        "Come si identifica il veicolo di destinazione quando vengono trovati più veicoli?",
      a:
        "È possibile determinare quale veicolo si desidera associare confrontando le informazioni sul numero di telaio. Il numero di telaio si trova solitamente vicino alla porta di ricarica sul sedile del veicolo o dove è stampato il VIN, come mostrato di seguito:\
      <div style='text-align:center;padding-top:24px;'><img src='/static/img/q3.png' width='180px' alt=''></div>"
    },
    {
      q: "Cosa fare se l'app dice 'Attivazione rete veicolo...'?",
      a:
        "1.Controllare se la connessione di rete del veicolo è normale.<br/>\
      È possibile controllare lo stato della rete sullo schermo del veicolo. Se il veicolo si trova sotto una rete scadente, si consiglia di spostarlo in un ambiente esterno all'aperto o in un ambiente con una buona rete.<br/>\
      2.Controllare se la connessione di rete del telefono cellulare è normale.<br/>\
      Lo stato di attivazione potrebbe non essere sincronizzato correttamente a causa di una rete telefonica anomala o instabile.<br/>\
      3.Controllare se l' 'autorizzazione di notifica' dell'applicazione è abilitato. È possibile accedere a Impostazioni del telefono→Notifiche→Applicazione→Apri l'autorizzazione di notifica; (il processo di funzionamento può variare a seconda del sistema operativo).<br/>\
      4.Puoi provare a riavviare l'app o disconnetterti dall'account di accesso dell'app e accedere nuovamente per risolvere il problema."
    },

    {
      q:
        "Il processo di connessione Bluetooth è completo dopo l'attivazione e il collegamento?",
      a:
        "Dopo l'attivazione e il collegamento riusciti, il telefono cellulare e il veicolo hanno completato solo il collegamento del modulo BLE (Bluetooth Low Energy) per la comunicazione di base tra il telefono cellulare e il veicolo.<br/>\
        Se è necessario utilizzare le funzioni Bluetooth, come la musica o le telefonate, accedere alle impostazioni del telefono e collegare il veicolo tramite il Bluetooth del telefono."
    },
    {
      q: "Come si fa a scollegare il veicolo?",
      a:
        "Accedi all'app, seleziona dalla barra laterale il veicolo che desideri scollegare, fai clic su Elimina veicolo, controlla l'accordo Elimina e fai clic su Elimina per scollegare correttamente."
    },

    {
      q:
        "Perché il veicolo non può entrare nello stato di attivazione sospesa dopo aver effettuato il collegamento da un account?",
      a:
        'Dopo lo scollegamento, se il veicolo non riesce a entrare di nuovo nello stato di attivazione in sospeso, la causa potrebbe essere la scarsa connessione di rete del veicolo corrente:<br/>\
      1.È possibile spostare il veicolo in un ambiente aperto dove la rete è buona e quindi riavviare il veicolo per verificarne lo stato;<br/>\
      2.Controllare se il servizio smart del veicolo è scaduto. In caso affermativo, rinnovare il canone e poi riavviare il veicolo per verificarne lo stato.<br/>\
      * Alcuni modelli possono accedere alla funzione di impostazione del veicolo, trovare la modalità "Modalità da vincolare" e impostare attivamente il veicolo da vincolare.'
    }
  ],
  [
    {
      q: "Come aggiornare/scollegare il mio numero di telefono?",
      a:
        "Per garantire la sicurezza dell'account, è necessario collegare un numero di cellulare dopo l'attivazione del veicolo. Pertanto, l'account utilizzato per attivare il veicolo non può essere scollegato direttamente. L'aggiornamento del numero di telefono è supportato. <br/>\
        Se è necessario aggiornare il numero di telefono, accedere alla pagina Impostazioni, entrare nel Centro sicurezza account, gestire il collegamento dell'account e fare clic sul numero di telefono per modificarlo."
    },
    {
      q: "Posso utilizzare l'account su più telefoni?",
      a:
        "L'accesso all'account non è limitato ai dispositivi mobili. Tuttavia, per proteggere la sicurezza dell'account e del veicolo, lo stesso account non può essere utilizzato contemporaneamente su più dispositivi mobili. In caso contrario, l'account verrà automaticamente disconnesso da altri dispositivi."
    },

    {
      q: "Come cancellare il mio account?",
      a:
        "L'applicazione supporta la cancellazione dell'account. Prima di farlo, assicuratevi che non ci siano veicoli collegati o servizi non completati o non pagati in questo account.<br/>\
        È possibile fare clic su Impostazioni → Sicurezza dell'account → Elimina account per eliminare l'account. Si prega di prestare attenzione prima di eliminare l'account, poiché l'operazione è irreversibile. Dopo l'eliminazione, non sarà più possibile accedere a nessun dato relativo all'account Blueshark."
    },

    {
      q: "Come gestire le autorizzazioni dei dati del mio veicolo?",
      a:
        "Attribuiamo grande importanza alla protezione della tua privacy e delle tue informazioni personali.<br/>\
        È possibile utilizzare l'app per realizzare, ma non solo, la visualizzazione delle condizioni del veicolo, il posizionamento dei veicoli, il posizionamento della propria posizione, la registrazione dinamica del veicolo, il controllo remoto dei veicoli, l'impostazione dei veicoli e altre funzioni.<br/>\
      In conformità con il principio della 'minimizzazione', otterremo direttamente o indirettamente la posizione del veicolo e le informazioni sul percorso di guida ed eseguiremo l'elaborazione della crittografia.<br/>\
      Puoi accedere alla pagina Gestione Veicolo e selezionare la funzione Dati Veicolo e Permessi per gestire i permessi. Dopo che una funzione è stata disabilitata, alcune funzioni potrebbero non essere più disponibili."
    }
  ],
  [
    {
      q: "Cosa devo preparare prima di guidare?",
      a:
        "Per garantire la vostra sicurezza, prima della guida eseguite i seguenti check:<br/>\
      1.Verificare che il veicolo sia normalmente acceso e che le condizioni di illuminazione e di altro tipo siano corrette;<br/>\
      2.Controllare che il freno anteriore e il freno posteriore funzionino correttamente;<br/>\
      3.Controllare se la pressione degli pneumatici è normale;<br/>\
      4.Controllare se il manubrio, le ruote anteriori e posteriori sono fissate e se il blocco della testa è disinserito;<br/>\
      5.Verificare che la batteria residua sia sufficiente;<br/>\
      6.Controllare se ci sono altri avvisi di guasto;<br/>\
      7.Indossare il casco e altri dispositivi di protezione."
    },

    {
      q: "Come avviare il veicolo?",
      a:
        "Puoi avviare il veicolo in diversi modi:<br/>\
        1.Chiave telecomando: (1) Fare clic sul pulsante di sblocco sul telecomando; (2) Portare con sé la chiave telecomando. Quando ti avvicini al veicolo, il pulsante di accensione (come il pulsante di accensione o il pulsante pronto) lampeggerà regolarmente. Premilo a lungo per avviare il veicolo;<br/>\
        2.App: (1) Apri l'app e fai clic su 'Avvia' per avviare il veicolo; (2)) Il veicolo è associato al telefono cellulare. Quando il veicolo è vicino al veicolo, il pulsante di accensione (come il pulsante di accensione o il pulsante pronto) lampeggerà regolarmente. Premilo a lungo per avviare il veicolo;<br/>\
        3.Sblocco dell'impronta digitale: alcuni modelli dispongono di aree di identificazione dell'impronta digitale, in modo che gli utenti possano avviare il veicolo con le proprie impronte digitali senza portare con sé chiavi o telefoni cellulari."
    },
    {
      q:
        "Perché non c'è potenza in uscita quando si gira il manubrio, anche se il veicolo è avviato?",
      a:
        "Per proteggere la vostra sicurezza di guida ed evitare situazioni rischiose come l'uscita veloce, il veicolo utilizza dei sensori per garantire un avviamento sicuro. Prima di partire, è necessario rilasciare il cavalletto laterale o il supporto centrale e sedersi sul veicolo.<br/>\
      Premendo il tasto 'READY' sul manubrio destro, l'indicatore 'READY' si accende e il veicolo è pronto per la guida. A questo punto, è possibile ruotare la manopola per iniziare a guidare.<br/>\
      Le funzioni di cui sopra sono disponibili solo per alcuni modelli, che possono essere attivate e disattivate tramite il centro del veicolo dell'APP mobile."
    },

    {
      q: "Cosa devo fare dopo aver terminato la guida?",
      a:
        "Quando raggiungi la tua destinazione, premi il pulsante 'READY' per annullare la modalità READY e abbassa il tutore laterale o centrale. <br/>\
        Puoi bloccare il tuo veicolo nei seguenti modi:<br/>\
        1.Telecomando: fare clic sul pulsante di blocco sul telecomando;<br/>\
        2.Telefono cellulare: apri l'app mobile e fai clic su 'Guardia' per bloccare il veicolo;<br/>\
        3.Veicolo: secondo la guida del manuale del veicolo, fortificare attraverso i pulsanti fisici sul manubrio del veicolo.<br/>\
        Dopo che il veicolo è bloccato, girare il rubinetto a sinistra e controllare se il blocco del rubinetto è bloccato."
    }
  ],
  [
    {
      q:
        "Cos'è la funzione di rilevamento elettronico del cavalletto laterale?",
      a:
        "Per garantire la vostra sicurezza, la funzione di rilevamento elettronico del cavalletto laterale viene utilizzata per rilevare lo stato di abbassamento o rilascio del cavalletto laterale. Quando si è pronti a guidare, questa funzione ricorda di rilasciare il cavalletto laterale prima di iniziare la marcia.<br/>\
        Questa funzione può essere attivata o disattivata tramite il sistema operativo del veicolo o le impostazioni dell'app. Si consiglia agli utenti inesperti di mantenere attiva questa funzione."
    },

    {
      q: "Cos'è la funzione di rilevamento della pressione del sedile?",
      a:
        "Per garantire la vostra sicurezza, la funzione di rilevamento della pressione del sedile (la funzione Easy Start per i modelli R1) viene utilizzata per rilevare se una persona è già seduta sul veicolo o meno. Quando si è pronti a guidare, questa funzione ricorda di sedersi saldamente prima di iniziare la marcia. <br/>\
        Questa funzione può essere attivata o disattivata tramite il sistema operativo del veicolo o le impostazioni dell'app. Si consiglia agli utenti inesperti di mantenere attiva questa funzione."
    },

    {
      q: "Cos'è la funzione di assistenza alla svolta?",
      a:
        "Per garantire la vostra sicurezza, la funzione di assistenza alla svolta attiva la telecamera posteriore durante la svolta per presentarvi le informazioni sulle condizioni della strada dietro di voi, compensando così l'angolo cieco.<br/>\
      (Questa funzione è supportata solo da alcuni modelli)"
    },
    {
      q: "Cos'è la funzione di assistenza alla retromarcia?",
      a:
        "Per garantire la vostra sicurezza, la funzione di assistenza alla retromarcia attiva la telecamera posteriore e il radar a ultrasuoni posteriore durante la retromarcia per mostrarvi gli ostacoli dietro il veicolo e la loro distanza, compensando così l'angolo cieco.<br/>\
     (Questa funzione è supportata solo da alcuni modelli)"
    }
  ],
  [
    {
      q: "Come si effettua l'accoppiamento con il telefono cellulare?",
      a:
        "1.Dopo aver parcheggiato in sicurezza il veicolo, aprire lo Smart Menu e selezionare le Impostazioni Bluetooth;<br/>\
      2.Selezionare 'Telefono cellulare', attivare il Bluetooth e fare clic per accoppiarlo al telefono cellulare;<br/>\
      3.Accedere alla sezione Bluetooth del telefono e accertarsi che il telefono cellulare venga trovato;<br/>\
      4.Sul veicolo, scegliere il telefono cellulare e accoppiarlo;<br/>\
      5.Il veicolo è in grado di ricordare i dispositivi mobili collegati in precedenza, quindi una volta che i dispositivi collegati sono vicini, possono connettersi al veicolo automaticamente. (I dispositivi iOS collegati in precedenza possono essere ricollegati solo quando il Bluetooth del telefono è acceso, mentre i dispositivi Android non sono interessati da questa regola).<br/>\
      6.Per disconnettersi da un dispositivo, è sufficiente scegliere il dispositivo corrispondente sul veicolo;<br/>\
      7.Se il veicolo non riesce a rilevare il vostro telefono cellulare, assicuratevi che la funzione Bluetooth del vostro telefono cellulare sia attivata e che abbiate aperto la sezione Bluetooth. Se il veicolo continua a non trovarlo, spegnere il Bluetooth e riaccenderlo."
    },

    // {
    //   q: "如何连接蓝牙耳机或蓝牙头盔？",
    //   a:
    //     "（目前该功能仅支持R1 车型）<br/>\
    //   1.在车辆驻车状态下，打开智能菜单选择蓝牙设置功能；<br/>\
    //   2.选择“耳机/头盔”并开启蓝牙功能，选择您的设备名称并连接；<br/>\
    //   3.打开手机，并打开蓝牙页面，以保证手机设备可以被搜索到；<br/>\
    //   4.若要断开链接，选择断开相应的设备即可。"
    // },
    {
      q: "Come attivare la funzione musicale Bluetooth?",
      a:
        "1. Assicurarsi che il telefono cellulare e le cuffie/caschi siano collegati al veicolo. In caso contrario, la musica verrà riprodotta attraverso l'altoparlante del veicolo;<br/>\
      2. Dopo l'avvio della riproduzione del telefono cellulare, è possibile ascoltare la musica attraverso il veicolo, indipendentemente dal fatto che sia parcheggiato o in viaggio.<br/>\
      3. È possibile utilizzare il pulsante play/pausa del veicolo per riprodurre e mettere in pausa la musica, premere il pulsante OK per riprodurre il brano successivo e fare clic sui pulsanti Più e Meno del volume per aumentare o abbassare il volume."
    }

    // {
    //   q: "如何使用蓝牙电话功能？",
    //   a:
    //     "（目前该功能仅支持R1 车型）<br/>\
    //   1.在车辆驻车状态下，打开智能菜单选择蓝牙电话功能；<br/>\
    //   2.请确保车辆已经连接了您的手机和耳机/头盔，需要您耳机/头盔的麦克风进行通话。<br/>\
    //   3.选择“同步通讯录”，将手机的最近联系人和通话记录同步到车机上；<br/>\
    //   4.我们为您提供了“最近联系人”“所有通话”“未接来电”三个选项，你可以在驻车状态下进行外呼。<br/>\
    //   最近联系人：车辆读取手机通讯录中最近有过通话的10个人；<br/>\
    //   所有通话：车辆显示最近3天的通话记录（最多20条）；<br/>\
    //   未接来电：车辆在所有通话中筛选出所有未接来电（最多20条）；<br/>\
    //   5.若有人向你呼入通话，你可通过按车机上的OK键接通，或使用“返回”键挂断。"
    // }
  ],
  [
    {
      q: "Posizionamento del veicolo",
      a:
        "Il veicolo ottiene la posizione attraverso il segnale GPS. Quando il veicolo si trova al chiuso o in un'area chiusa come un seminterrato, la precisione del posizionamento del veicolo ne risente. Spostando il veicolo in un ambiente aperto, la funzione GPS tornerà normale.<br/>\
      Il percorso di guida viene creato collegando i punti di posizionamento segnalati dal veicolo in un determinato periodo di tempo. A causa dell'imprecisione di posizionamento e dell'occlusione del segnale, potrebbero verificarsi posizionamenti errati o addirittura la perdita di punti di posizionamento, con conseguenti percorsi anomali o imprecisi.<br/>\
      Se non si riesce a localizzare il veicolo per molto tempo o se la maggior parte dei percorsi di guida non sono corretti, verificare se lo Smart Service del veicolo è scaduto. In caso contrario, è possibile contattare il centro di assistenza per controllare la rete e il GPS del veicolo."
    },

    {
      q: "Notifiche push",
      a:
        "È possibile risolvere i problemi seguendo le seguenti istruzioni:<br/>\
      1.Andare al Centro messaggi nell'angolo in alto a destra della homepage dell'app per confermare se è possibile ricevere messaggi push come 'vibrazione del veicolo';<br/>\
      2.Gestire le impostazioni di notifica del telefono. Andare alla pagina Impostazioni, selezionare Notifiche, selezionare l'app e assicurarsi che le notifiche siano consentite.<br/>\
      3.Selezionate il veicolo nell'app, selezionate la modalità Sicurezza del veicolo e verificate se le notifiche push sono consentite."
    },

    {
      q: "Che cos'è la modalità Sicurezza del veicolo?",
      a:
        "Per garantire la sicurezza del veicolo, le notifiche vengono inviate per avvisare l'utente di eventi anomali come vibrazioni del veicolo, movimento delle ruote, scollegamento della batteria, scaricamento eccessivo della batteria, ecc.<br/>\
      È possibile selezionare la modalità Allarme o la modalità Non disturbare in base a dove è parcheggiato il veicolo e personalizzare le impostazioni di sicurezza.<br/>\
      Se il veicolo si muove, è possibile controllare la posizione attuale del veicolo per assicurarsi che sia sicuro."
    },

    {
      q: "Autonomia di guida stimata in modo impreciso con una carica",
      a:
        "L'autonomia stimata del veicolo è calcolata in base alle abitudini di guida dell'utente e alla cronologia dei consumi corrispondenti. L'accuratezza dell'autonomia stimata è influenzata da vari fattori, quali le condizioni di carico, le condizioni stradali e la temperatura ambientale. In genere, uno scarto del 20% è normale.<br/>\
        Se lo scarto è ovviamente troppo grande o troppo piccolo, di solito non è un problema della batteria, ma è dovuto alla stabilità dei dati o a errori di dati. Se, dopo aver guidato più volte, lo scarto è ancora elevato, si prega di contattare il servizio di assistenza post-vendita per un'ulteriore risoluzione dei problemi."
    },

    {
      q: "Cosa devo fare se il veicolo non risponde al telecomando?",
      a:
        "Controllare se la rete del telefono cellulare è buona e, nell'angolo in alto a destra della homepage dell'app, controllare se la connessione Bluetooth e di rete sono normali. Se la connessione a Internet o al Bluetooth è buona, è possibile impartire il comando di controllo remoto."
    }
  ],
  [
    {
      q: "Qual è lo scopo dell'aggiornamento del veicolo?",
      a:
        "Lo scopo principale degli aggiornamenti OTA è migliorare l'esperienza dell'utente e ottimizzare le funzioni del veicolo. Ogni volta che è disponibile un aggiornamento OTA, i dettagli dell'aggiornamento vengono segnalati. Per i dettagli, consultare la pagina al momento dell'aggiornamento."
    },
    {
      q: "Quali sono i requisiti per aggiornare il veicolo?",
      a:
        "1.Assicurarsi che il veicolo sia avviato e parcheggiato. Assicurarsi che la batteria residua del veicolo sia superiore al 20%. NON rimuovere la batteria durante l'aggiornamento.<br/>\
      2.Assicurarsi che il Bluetooth e la rete cellulare del telefono siano accesi. Avvicinarsi al veicolo e tenere il telefono cellulare e il veicolo collegati."
    },

    {
      q:
        "A cosa devo prestare attenzione durante il processo di aggiornamento?",
      a:
        "1.Durante l'aggiornamento, non guidare il veicolo e assicurarsi che sia acceso e non in marcia; <br/>\
      2.Durante l'aggiornamento, si prega di non stare lontano dal veicolo e di mantenere il veicolo e il telefono cellulare sempre connessi; <br/>\
      3.Dopo l'avvio dell'aggiornamento, NON rimuovere la batteria del veicolo; <br/>\
      4.Dopo l'avvio dell'aggiornamento, NON spegnere lo schermo o l'applicazione e mantenere attivi la rete cellulare e il Bluetooth del telefono cellulare."
    },

    {
      q: "Perché il trasferimento dei file si interrompe sempre?",
      a:
        "Nel processo di aggiornamento del veicolo, il telefono cellulare è connesso al veicolo tramite rete WiFi per la trasmissione dei file. Durante il trasferimento dei file, il telefono cellulare non è in alcuno stato di rete. Al termine del trasferimento del file, la rete di telefonia mobile viene ripristinata.<br/>\
        Alcuni utenti di telefoni cellulari IOS ricorderanno all'utente che lo stato corrente della rete non è buono, se disconnettersi o cambiare rete, scegliere di continuare a utilizzare la rete corrente;<br/>\
        Per alcuni utenti di telefoni cellulari Android, disabilitare la funzione di selezione WLAN recente perché disconnette o cambia automaticamente la rete. Puoi abilitarlo dopo che il trasferimento del file è stato completato."
    },

    {
      q:
        "L'aggiornamento è terminato, ma non sono sicuro che sia andato a buon fine.",
      a:
        "Non allontanarsi dal veicolo durante l'aggiornamento e mantenere il Bluetooth connesso.<br/>\
        Durante il processo di aggiornamento del veicolo, l'avanzamento e lo stato dell'aggiornamento verranno presentati rispettivamente nel sistema del motore del veicolo e nel terminale dell'app.<br/>\
      Se la connessione viene interrotta a causa di circostanze particolari, puoi provare a riconnettere il veicolo. Oppure aggiorna la pagina di aggiornamento del sistema per visualizzare la versione corrente del veicolo. Se viene visualizzata la versione più recente, l'aggiornamento ha esito positivo. Se alcuni componenti non sono della versione più recente, aggiornali nuovamente."
    }
  ],
  [
    {
      q: "Come si carica la batteria?",
      a:
        "Il veicolo supporta una varietà di modalità di ricarica e rifornimento:<br/>\
      1.Caricatore:<br/>\
      Si prega di posizionare la base di ricarica su una superficie piana e assicurarsi che la temperatura dell'ambiente non sia né troppo alta né troppo bassa e che l'ambiente non sia umido. Collegare il caricabatterie a ricarica diretta all'alimentatore, quindi connettere la base di ricarica al caricabatterie a ricarica diretta e posizionare la batteria sulla base correttamente per avviare la ricarica. Quando è necessario caricare due batterie contemporaneamente, connettere lo sdoppiatore al caricatore e alle due basi di ricarica rispettivamente.<br/>\
      La base di ricarica deve essere utilizzata insieme a un caricabatterie a ricarica diretta.<br/>\
      2.Ricarica diretta:<br/>\
      Puoi caricare il veicolo mentre le batterie sono all'interno. Collega l'alimentatore al connettore di ricarica e puoi dire se la batteria è carica attraverso lo schermo.<br/>\
      3.BSS:<br/>\
      Parte dell'area copre la rete di ricarica del BSS, che può essere modificata tramite il BSS aprendo il servizio di scambio."
    },

    {
      q: "Quali sono le precauzioni da adottare durante l'uso della batteria?",
      a:
        "1.Ambiente di funzionamento della batteria:<br/>\
        -10~45℃; <br/>\
        Evitare che la batteria sia impregnata di liquidi;<br/>\
        Evitare che oggetti metallici estranei entrino nel vano batteria; <br/>\
        Evitare di posizionare la batteria vicino a oggetti luminosi, infiammabili ed esplosivi. <br/>\
      2.Attenuazione della capacità della batteria: <br/>\
      In condizioni di bassa temperatura, la capacità utilizzabile della batteria si attenua in misura variabile. Il valore di riferimento è: <br/>\
      Quando la temperatura è di -10 ℃, la capacità utilizzabile della batteria è di circa il 70%; <br/>\
      0 ℃, circa 85%; <br/>\
      25 ℃, circa il 100%; <br/>\
      3. Precauzioni per la sicurezza della batteria: <br/>\
      Se la batteria si surriscalda, si deforma o produce odori, smettere immediatamente di usarla e stare lontani dalla batteria. Contattare il centro di assistenza post-vendita per l'ispezione e la riparazione. Non smontare la batteria da soli. Se la batteria viene smontata senza autorizzazione, possono verificarsi incidenti come incendi ed esplosioni e la garanzia della batteria non è più valida."
    },

    {
      q: "Come prolungare la durata della batteria?",
      a:
        "La durata della batteria è determinata principalmente dal numero di cicli di carica e dall'ambiente di conservazione. Per ciclo di carica si intende il processo di scaricamento completo di una batteria carica al 100% e la successiva ricarica completa. Delle buone abitudini sono quella di conservare la batteria con almeno il 50% in un ambiente asciutto con una temperatura compresa tra 0°C e 25°C ed evitare la scarica eccessiva, entrambe possono contribuire a prolungare la durata della batteria."
    }
  ],
  [
    {
      q: "Istruzioni per la manutenzione del veicolo",
      a:
        "1.Attuazione della manutenzione regolare<br/>\
        La manutenzione regolare può prolungare efficacemente la durata dei veicoli. L'utente può eseguire regolarmente la manutenzione del veicolo in base ai promemoria del sistema del veicolo o dell'app.<br/>\
      Senza una manutenzione regolare, il veicolo potrebbe presentare rischi per la sicurezza, con conseguenti malfunzionamenti o incidenti. Durante il processo di manutenzione, se si riscontrano anomalie nel veicolo, portarlo presso un negozio specializzato o un centro di assistenza per l'ispezione e la riparazione.<br/>\
      2.Metodi di manutenzione <br/>\
      Nel manuale sono stati introdotti alcuni elementi di controllo principali. Per un'ispezione più approfondita, recarsi presso il negozio o il centro di assistenza designato, oppure eseguire la manutenzione secondo il manuale di assistenza post-vendita Blueshark.<br/>\
      Durante la manutenzione ordinaria, prestare attenzione e attenersi ai seguenti consigli:<br/>\
      Prima di eseguire la manutenzione ordinaria, scegliere uno spazio aperto e pianeggiante, abbassare il supporto centrale del veicolo e iniziare la manutenzione del veicolo.<br/>\
      Dopo un lungo viaggio, alcuni componenti elettronici del veicolo potrebbero surriscaldarsi. Non smontare immediatamente le parti così da evitare danni.<br/>\
      Durante la manutenzione ordinaria, se si riscontra un'anomalia nel veicolo, effettuare le opportune regolazioni il prima possibile. Se l'anomalia non può essere risolta da soli, recarsi presso il negozio designato o il centro di assistenza per un controllo completo."
    }
  ],
  [
    {
      q: "Il veicolo non può essere avviato",
      a:
        "Fase 1:<br/>\
      Controllare se l'interruttore di alimentazione è acceso; in caso contrario, accendere l'interruttore di alimentazione del veicolo;<br/>\
      Fase 2:<br/>\
      Controllare se la batteria del telecomando è esaurita. È possibile verificarlo se la spia sul tasto del telecomando è spenta o lampeggiante; se è spenta, sostituire la batteria:<br/>\
      Fase 3:<br/>\
      Controllare se la batteria del veicolo è inserita; in caso contrario, inserire una batteria con potenza sufficiente; se la batteria è scarica, caricarla secondo le istruzioni.<br/>\
      Se non si riesce ancora ad avviare il veicolo dopo aver provato i metodi sopra descritti, si prega di contattare il negozio o il centro di assistenza designato per l'ispezione e la riparazione."
    },
    {
      q: "Perché la distanza di guida si riduce dopo la ricarica?",
      a:
        "Fase 1:<br/>\
      Controllare se i pneumatici sono danneggiati o se la loro pressione è insufficiente. In tal caso, sostituire il pneumatico o gonfiarlo;<br/>\
      Fase 2:<br/>\
      Controllare se la temperatura ambientale è troppo bassa, poiché la bassa temperatura dell'ambiente di guida influisce sull'efficienza di scarica della batteria, è un fenomeno normale. Assicurarsi che l'ambiente di ricarica sia compreso tra 5℃ e 55℃:<br/>\
      Fase 3:<br/>\
      Verificare se il tempo di ricarica della batteria è troppo breve. Assicurarsi che il metodo di ricarica sia corretto e che la spina di ricarica sia collegata correttamente;<br/>\
      * Dopo aver caricato e scaricato la batteria molte volte, la capacità totale della batteria può attenuarsi in una certa misura, il che è un fenomeno normale;<br/>\
      Se le condizioni di cui sopra sono state esaminate e il problema persiste, si prega di portare il veicolo al negozio o al centro di assistenza designato per l'ispezione e la riparazione."
    },
    {
      q: "Il caricabatterie genera calore durante la ricarica",
      a:
        "In genere, la temperatura del caricabatterie aumenta durante il processo di ricarica, il che è un fenomeno normale.<br/>\
      Se il caricabatterie diventa troppo caldo per essere toccato con le mani, si prega di interrompere immediatamente l'alimentazione per interrompere la carica e di inviare il caricabatterie a un negozio o a un centro di assistenza designato per l'ispezione e la riparazione."
    },

    {
      q: "Codici di errore e consigli per la risoluzione dei problemi",
      a: troubles
    }
  ]
];



// WEBPACK FOOTER //
// ./src/assets/js/helpMultilngual/bs_it_questions.js